export var noop = function noop() {};


//////////////////
// WEBPACK FOOTER
// /home/runner/work/medischeartikelen-website/medischeartikelen-website/node_modules/@algolia/autocomplete-shared/dist/esm/noop.js
// module id = 70
// module chunks = 0